{
  "tabs": {
    "lintTriage": "Lint-Triage",
    "testFailures": "Testfehler",
    "playwrightTests": "Playwright-Tests"
  },
  "fixWithClaudeDialog": {
    "title": "Mit Claude beheben - {{fileName}}",
    "runningInBackground": "Läuft im Hintergrund (Dialog kann geschlossen werden)",
    "startingClaude": "Starte Claude...",
    "fileChangesAccordion": "Dateiänderungen (git diff)",
    "noChangesDetected": "Keine Änderungen erkannt",
    "status": {
      "success": "✅ Korrektur erfolgreich abgeschlossen!",
      "cancelled": "⚠️ Korrektur abgebrochen",
      "error": "❌ Korrektur fehlgeschlagen (siehe oben)"
    },
    "buttons": {
      "cancel": "Abbrechen",
      "clear": "Löschen",
      "close": "Schließ"
    }
  },
  "playwrightTests": {
    "title": "Playwright-Tests",
    "loading": "Lädt Playwright-Tests...",
    "testCount": "{{count}} Tests · ca. {{duration}}",
    "buttons": {
      "retry": "Nochmal",
      "runningTests": "Führe Tests aus...",
      "runAllTests": "Alle Tests starten"
    },
    "alerts": {
      "noTestsFound": "Keine Playwright-Testergebnisse gefunden. Klicke auf Alle Tests ausführen, um die Testsuite auszuführen.",
      "runningTests": "Playwright-Tests werden ausgeführt... Das kann einige Minuten dauern."
    },
    "execution": {
      "started": "Testausführung gestartet ({{processId}})",
      "completed": "Testausführung abgeschlossen mit Code {{code}}"
    }
  },
  "fileCard": {
    "errorCounts": {
      "eslint": "ESLint",
      "typescript": "TypeScript",
      "total": "Gesamt"
    },
    "buttons": {
      "viewErrors": "Fehler anzeigen",
      "copyAll": "Alles für Claude kopieren",
      "fixAllWithClaude": "Mit Claude beheben",
      "viewProgress": "Fortschritt anzeigen...",
      "fixed": "Behoben ✓",
      "fixFailed": "Fehler ✗"
    }
  },
  "fileErrorsView": {
    "buttons": {
      "backToFiles": "Zurück zu Dateien",
      "copyAllErrors": "Alle {{count}} Fehler kopieren",
      "openInVSCode": "In VSCode öffnen",
      "copyIndividual": "Einzelperson kopieren"
    },
    "errorCounts": {
      "eslint": "ESLint",
      "typescript": "TypeScript",
      "total": "Gesamt",
      "line": "Zeile {{number}}"
    },
    "snackbar": {
      "copiedAll": "Alle {{count}} Fehler für Claude kopiert!",
      "copiedLine": "Fehler aus Zeile {{line}} kopiert"
    }
  },
  "playwrightTestDetail": {
    "buttons": {
      "backToTests": "Zurück zu Tests",
      "viewScreenshots": "Screenshots anzeigen ({{count}})",
      "viewVideos": "Videos anzeigen ({{count}})",
      "updateSnapshots": "Snapshots aktualisieren",
      "updating": "Aktualisiere...",
      "fixWithClaude": "Mit Claude beheben"
    },
    "labels": {
      "errorMessage": "Fehlermeldung:"
    },
    "messages": {
      "testPassed": "Dieser Test war erfolgreich!",
      "snapshotsUpdated": "Snapshots erfolgreich aktualisiert!",
      "snapshotsFailed": "Snapshots konnten nicht aktualisiert werden. Details findest du in der Konsole.",
      "error": "Fehler: {{message}}",
      "claudeComingSoon": "Claude-Fix-Integration kommt bald!"
    }
  }
}
